namespace SorAraBul {
    export enum PropertyTypes {
        ev = 0,
        dukkan = 1,
        ofis = 2
    }
    Serenity.Decorators.registerEnumType(PropertyTypes, 'SorAraBul.PropertyTypes');
}
